export default {
    
'BRSkinny': 'Skinny',
'BRHealth': 'Health',
'BRStrength': 'Strength',
'BRAppearance': 'Appearance',
'BRMuscular': 'Muscular',
'BRCorpulent': 'Corpu- lent',
'BREndurance': 'Endurance',
'W workouts with R repetitions': '{W} workouts with {R} repetitions',
'BRAverage': 'Average',
'O from M': '{O} of {M}',
'Repetitions with B sec break': 'Repeats with {B} sec break',
'S km stretch': 'Route of {S} km'
}


// WEBPACK FOOTER //
// ./src/i18n/ke.js